import * as React from 'react';
import { Switch, Route, withRouter, RouteComponentProps } from 'react-static';

import { routePaths } from '../../../config/routePaths';

import HomePage from '../HomePage/HomePage';
import FaqPage from '../FaqPage/FaqPage';
import ConnectionPage from '../ConnectionPage/ConnectionPage';
import PrivacyPage from '../PrivacyPage/PrivacyPage';
import LocationsPage from '../LocationsPage/LocationsPage';
import StatisticsPage from '../StatisticsPage/StatisticsPage';
import ServicesPricingPage from '../ServicesPricingPage/ServicesPricingPage';
import NetworksPage from '../NetworksPage/NetworksPage';
import ContactPage from '../ContactPage/ContactPage';
import TechnicalPage from '../TechnicalPage/TechnicalPage';
import AboutPage from '../AboutPage/AboutPage';
import NotFoundPage from '../NotFoundPage/NotFoundPage';

const Routes: React.SFC<RouteComponentProps<{}>> = ({ location }) => {
  const renderRouteForAllLang = (
    pathsObject: { [key: string]: string },
    Component: React.ComponentType,
  ) =>
    Object.entries(pathsObject).map(([lang, path]) => (
      <Route key={lang} exact path={path} component={Component} />
    ));

  return (
    <Switch location={{ ...location, pathname: location.pathname.replace(/^\/*/, '/') }}>
      {renderRouteForAllLang(routePaths.homepage, HomePage)}}
      {renderRouteForAllLang(routePaths.faq, FaqPage)}
      {renderRouteForAllLang(routePaths.connection, ConnectionPage)}
      {renderRouteForAllLang(routePaths.privacy, PrivacyPage)}
      {renderRouteForAllLang(routePaths.locations, LocationsPage)}
      {renderRouteForAllLang(routePaths.statistics, StatisticsPage)}
      {renderRouteForAllLang(routePaths.servicesPricing, ServicesPricingPage)}
      {renderRouteForAllLang(routePaths.networks, NetworksPage)}
      {renderRouteForAllLang(routePaths.contactSales, ContactPage)}
      {renderRouteForAllLang(routePaths.contactSupport, ContactPage)}
      {renderRouteForAllLang(routePaths.technical, TechnicalPage)}
      {renderRouteForAllLang(routePaths.about, AboutPage)}
      <Route path="/cz/404" component={NotFoundPage} />
      <Route component={NotFoundPage} />
    </Switch>
  );
};

export default withRouter(Routes);



// WEBPACK FOOTER //
// /www/client/src/containers/App/Routes.tsx